import styled from 'styled-components';
import { Caption, Link } from '@increasecard/typed-components';
import { useTranslation } from 'react-i18next';
import { routes } from '../routes';

export const FooterContainer = styled.div`
  width: 100%;
  background-color: white;
  border-top: 1px solid ${(props) => props.theme.colors.brandWhite.medium};
  height: 56px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  align-items: center;
  span {
    font-weight: 600;
  }
  .links {
    display: flex;
    gap: 16px;
  }
`;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <FooterContainer className="footer">
      <div className="links">
        <Link small href={routes.legal.privacyPolicy} rel="noopener noreferer" target="_blank">
          {t('common:privacyPolicy')}
        </Link>
        <Link small href={routes.legal.termsAndConditions} rel="noopener noreferer" target="_blank">
          {t('common:termsAndConditions')}
        </Link>
      </div>
      <Caption>© Click de pago</Caption>
    </FooterContainer>
  );
};

export default Footer;
